import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ResponseNotificationService } from '../../core/services/response-notification.service';
import { Notification } from '../../core/interfaces/notification';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from "../modal/modal.service";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class NotificationComponent {

  public content: Notification;
  public type: number = null;
  public readonly defaultLife = 5000;

  constructor(
    private rns: ResponseNotificationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private modalService: ModalService
  ) {
    this.rns.notification.subscribe(data => {
      this.content = data.content;
      this.type = data.type;

      switch (this.type) {
        case ResponseNotificationService.MESSAGE: this.showMessage(); break;
        case ResponseNotificationService.VALIDATION_ERROR: this.showError(); break;
        case ResponseNotificationService.VALIDATION_WARNING: this.showWarning(); break;
      }
    });
  }

  showWarning(): void {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant(this.content.heading),
      detail: this.content.message,
      life: this.defaultLife,
      sticky: false
    });
  }

  showError(): void {
    this.messageService.add({
      severity: 'error',
      summary: this.translate.instant(this.content.heading),
      detail: this.content.message,
      life: this.defaultLife,
      sticky: false,
      data: {errorCode: this.content?.errorCode ?? null, errorContext: this.content?.errorContext ?? null}
    });
  }
  showMessage(): void {
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant(this.content.heading),
      detail: this.content.message,
      life: this.defaultLife,
      sticky: false
    });
  }

  public openBugReport(message: any): void {
    this.modalService.showBugReportModal({
      errorCode: message?.data?.errorCode ?? null,
      errorContext: message?.data?.errorContext ?? null
    });
  }

  public getMessageLife(message: any): number {
    return Number(message?.life) || this.defaultLife;
  }

  public getSeverityIcon(severity: string): string {
    switch (severity) {
      case 'error': return 'pi pi-times-circle';
      case 'warn': return 'pi pi-exclamation-triangle';
      case 'success': return 'pi pi-check-circle';
      default: return 'pi pi-info-circle';
    }
  }
}
